import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FORGOT_PASSWORD,
  GET_LOGGED_IN_USER_DETAILS,
  LOGIN,
  NEW_USER_RESET_PASSWORD,
  RESET_PASSWORD,
  VALIDATE_UUID,
  VERIFY_OTP,
} from "../../helpers/url_helper";
import { get, patch, post } from "../../helpers/api_helper";

export const login = createAsyncThunk(LOGIN, async (payload) => {
  const response = await post(LOGIN, payload);
  return response;
});

export const forgotPassword = createAsyncThunk(
  FORGOT_PASSWORD,
  async (payload) => {
    const response = await post(FORGOT_PASSWORD, payload);
    return response;
  }
);

export const verifyOtp = createAsyncThunk(VERIFY_OTP, async (payload) => {
  const response = await post(VERIFY_OTP, payload);
  return response;
});

export const resetPassword = createAsyncThunk(
  RESET_PASSWORD,
  async (payload) => {
    const response = await patch(RESET_PASSWORD, payload);
    return response;
  }
);

export const validateUUID = createAsyncThunk(VALIDATE_UUID, async (payload) => {
  const response = await post(VALIDATE_UUID, payload);
  return response;
});

export const resetNewPassword = createAsyncThunk(
  NEW_USER_RESET_PASSWORD,
  async (payload) => {
    const response = await patch(NEW_USER_RESET_PASSWORD, payload);
    return response;
  }
);

export const getAdminUserDetails = createAsyncThunk(
  GET_LOGGED_IN_USER_DETAILS,
  async (payload) => {
    const response = await get(GET_LOGGED_IN_USER_DETAILS);
    return response;
  }
);
